<template>
  <div v-if="visible">
    <div :class="advert_class">
      <div class="seniorpic">
        <a href="javascript:;" class="applyButton" @click="apply"></a>
        <a href="javascript:;" class="closeIcon" @click="collapse"></a>
      </div>
    </div>
    <a href="javascript:;" :class="btn_class" @click="expand"></a>
  </div>
</template>

<script>
export default {
  name: "advert",
  data() {
    return {
      advert_class: "senior",
      btn_class: "applyNotexpanded",
      timer: {},
      visible: false,
    };
  },
  created() {
    setTimeout(() => {
      this.visible = true;
      this.timer = setTimeout(() => {
        this.collapse();
      }, 10000);
    }, 5000);
  },
  methods: {
    expand() {
      this.advert_class = "senior-expand";
      this.btn_class = "applyNotexpanded-collapse";
    },
    collapse() {
      this.advert_class = "senior-collapse";
      this.btn_class = "applyNotexpanded-expand";
      clearTimeout(this.timer);
    },
    apply() {
      if (this.$store.state.userId === 0) {
        window.location.href = this.$store.state.login_url;
        return false;
      }
      this.$inquiry();
      this.collapse();
    },
  },
};
</script>

<style scoped>
.senior {
  height: 180px;
  background: rgba(11, 21, 38, 0.9);
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 9999999;
}
.senior-expand {
  height: 180px;
  background: rgba(11, 21, 38, 0.9);
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 9999999;
  animation-name: advert-expand;
  visibility: hidden;
  animation-duration: 1s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
}
.senior-collapse {
  height: 180px;
  background: rgba(11, 21, 38, 0.9);
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 9999999;
  animation-name: advert-collapse;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}
.seniorpic {
  background: url("/images/adv_img_cip@2x.png") no-repeat;
  width: 1200px;
  margin: 0 auto;
  height: 180px;
  background-size: 1200px;
  position: relative;
}
.closeIcon {
  width: 20px;
  height: 20px;
  background: url("/images/pop_close@2x.png") no-repeat;
  background-size: 20px;
  position: absolute;
  right: 0px;
  top: 17px;
}
.applyButton {
  width: 80px;
  height: 80px;
  background: url("/images/adv_button_app@2x.png") no-repeat;
  background-size: 80px;
  right: 160px;
  top: 50px;
  display: block;
  position: absolute;
}
.applyNotexpanded {
  width: 55px;
  height: 110px;
  background: rgba(11, 21, 38, 0.9) url("/images/adv_icon_open@2x.png") no-repeat 12px
    37px;
  background-size: 29px;
  border-radius: 0px 100px 100px 0px;
  position: fixed;
  left: 0px;
  bottom: 60px;
  visibility: hidden;
}
.applyNotexpanded-collapse {
  width: 55px;
  height: 110px;
  background: rgba(11, 21, 38, 0.9) url("/images/adv_icon_open@2x.png") no-repeat 12px
    37px;
  background-size: 29px;
  border-radius: 0px 100px 100px 0px;
  position: fixed;
  left: 0px;
  bottom: 60px;
  animation-name: advert-expand-btn;
  animation-duration: 1.3s;
  animation-fill-mode: forwards;
}
.applyNotexpanded-expand {
  width: 55px;
  height: 110px;
  background: rgba(11, 21, 38, 0.9) url("/images/adv_icon_open@2x.png") no-repeat 12px
    37px;
  background-size: 29px;
  border-radius: 0px 100px 100px 0px;
  position: fixed;
  left: 0px;
  bottom: 60px;
  visibility: hidden;
  animation-name: advert-collapse-btn;
  animation-duration: 1.3s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

@keyframes advert-collapse {
  from {
    left: 0%;
  }
  to {
    left: -100%;
    visibility: hidden;
  }
}

@keyframes advert-collapse-btn {
  from {
    left: -100%;
    visibility: hidden;
  }
  to {
    left: 0%;
    visibility: visible;
  }
}

@keyframes advert-expand {
  from {
    left: -100%;
    visibility: hidden;
  }
  to {
    left: 0%;
    visibility: visible;
  }
}

@keyframes advert-expand-btn {
  from {
    left: 0%;
  }
  to {
    left: -100%;
    visibility: hidden;
  }
}
</style>
